<template>
    <div v-if="banners.length" class="container mt-2">
        <div class="banners__wrapper">
            <a v-for="banner in banners" :key="banner.id" :href="banner.url" class="banners__item">
                <img class="banners__img" :src="banner.image" alt="Баннер" :width="banner.size.width" :height="banner.size.height" />
            </a>
        </div>
    </div>
</template>

<script>
import BannersApi from '../../api/banners.api'
import {mapActions, mapState} from "vuex";

export default {
    name: "Banners",
    created() {
        this.pullBanners();
    },
    computed: {
        ...mapState('Banners', ['banners'])
    },
    methods: {
        ...mapActions('Banners', ['fetchBanners']),
        async pullBanners() {
            await this.fetchBanners()
        },
    },
};
</script>

<style lang="scss" scoped>
.banners {
    &__wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    &__item {
        margin-right: 10px;
        margin-bottom: 10px;
        @media screen and (min-width: 1201px) {
            &:nth-child(3n) {
                margin-right: 0;
            }
        }
        @media screen and (max-width: 1200px) {
            &:nth-child(2n) {
                margin-right: 0;
            }
        }
        @media screen and (max-width: 768px) {
            margin-right: 0;
        }
    }
    &__img {
        max-width: 100%;
    }
}
</style>
